export default __webpack_public_path__ + "static/media/setting.2c6e13c6.svg";